import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Segment
} from "semantic-ui-react";

import AppHeaderDesktop from "./AppHeaderDesktop";
import AppFooter from "./AppFooter";

class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    return (
      <div className="all">
        <div className="main">
          <Segment vertical inverted color="pink" style={{paddingTop: 0}}>
            <AppHeaderDesktop />
          </Segment>
          {children}
        </div>
        <AppFooter />
      </div>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node
};

const AppContainer = ({ children }) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
  </div>
);

AppContainer.propTypes = {
  children: PropTypes.node
};

export default AppContainer;
